import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { PapiExtendedDeviation } from '@wix/da-papi-types';
import License from '../../../License';
import { DetailsProps } from '../types';
import JournalTags from '../_partials/JournalTags';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';
import TextualContent from '../../TextualContent';
import GruserZoneLocal from '../../GruserZone/Local';

import s from './Journal.scss';

const Journal: React.FC<DetailsProps> = ({
  deviation,
  deviation: {
    deviationId,
    author,
    publishedTime,
    textContent,
    license,
    extended: { tags, journalSkinFullwidth } = {} as PapiExtendedDeviation,
  },
  className,
  contentClassName,
}) => {
  const isMobile = useContext(MobileContext);
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
  const isLegacy = textContent?.html.type === 'writer';
  const isLegacyView = isLegacy && !journalSkinFullwidth;
  const isFullWidthView = isLegacy && journalSkinFullwidth;

  return (
    <div
      className={classnames(
        s['root'],
        isLegacyView && s['is-legacy-journal'],
        isFullWidthView && s['is-fullwidth-skin'],
        className,
        contentClassName
      )}
    >
      {isMobile && <TextualContent deviation={deviation} withArtist={false} />}
      {isExtendedLoaded && (
        <>
          {tags && <JournalTags key={`detailsTags-${deviationId}`} tags={tags} />}
          <div className={s['misc']}>
            <DeviationAttributeCSV deviation={deviation} />

            <div className={s['license']}>
              <License
                license={license}
                author={author}
                publishedTime={publishedTime}
                showSymbol={false}
              />
            </div>
          </div>
        </>
      )}
      {!isMobile && <GruserZoneLocal deviation={deviation} />}
    </div>
  );
};
Journal.displayName = 'Journal';

export default Journal;
